import styled from '@emotion/styled'

import TemplateHero from '@/components/templates/TemplateHero'
import TemplateHeader from '@/components/templates/TemplateHeader'
import { TemplateButton } from '@/components/templates/TemplateButton'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  height: 80px;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 3em;
`

Layout.Link = styled.span`
  margin-left: 10px;
  font-weight: 700;
  font-size: 16px;
  color: #0c0c0c;
`

Layout.SubHeader = styled.div`
  display: flex;
  background: ${({ theme }) => theme.palette.primary.main};
  color: white;
  height: 60px;
`

Layout.SubHeaderTitle = styled.span`
  margin: auto;
`

Layout.Hero = styled(TemplateHero)``

Layout.HeroContainer = styled.div`
  min-height: calc(var(--preview-height) - 80px - 60px);
  max-height: calc(var(--preview-height) - 80px - 60px);
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
`

Layout.TitleBox = styled.div`
  width: 41%;
  margin: auto 1em;
  padding: 0 15px;
`
Layout.TitleContainer = styled.div`
  background: ${({ theme }) => theme.palette.primary.main};
  padding: 2em 2em;
`

Layout.Title = styled.h1`
  font-size: 36px;
  font-weight: 500;
  align-self: center;
  z-index: 5;
`

Layout.Subtitle = styled.p`
  font-size: 17px;
  margin-top: 1em;
`

Layout.TitleDescription = styled.p`
  margin-bottom: 1em;
  font-size: 17px;
  color: ${({ theme }) => theme.palette.secondary.main};
  text-transform: uppercase;
`
Layout.CTA = styled(TemplateButton)`
  line-height: 2.2;
  padding: 5px 30px;
  margin: 38px 0 0;
  border-radius: 5px;
  border-width: 2px;
  font-size: 15px;
  font-weight: 500;
`

export default Layout
